import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
    container: {
        paddingLeft: 25,
        paddingRight: 25,
    },
    hrLine: {
        height: 0.5,
        position: 'relative',
        borderWidth: 0.5,
        marginTop: 10,
        marginBottom: 10,
        borderColor: "#2C2C2E",
    },
    titleDescription: {
        fontSize: 16,
        fontWeight: 'bold',
        marginBottom: 10,
        marginTop: 10
    },
    titleDescriptionFiles: {
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 10
    },
    contentDescription: {
        textAlign: 'justify',
        marginBottom: 20
    },
    contentFiles: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: 20
    },
    valueCoin: {
        fontWeight: '400',
        marginBottom: 20
    }
});

export default styles;
